export const fixPaths = (html: string) => {
	return html.replace(
		/(href="\/|src="\/|poster="\/|url\(\/'|url\("\/|url\(\/)/g,
		substr =>
			`${substr.replace(/\/$/, '')}${window.location.origin.replace(
				/\/$/,
				'',
			)}/`,
	)
}

// The receiver never runs snapshot scripts, so every <script> is dead weight in the upload.
export const removeScripts = (html: string) =>
	html.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '')

// The receiver renders the snapshot with scripts disabled, which would make <noscript> content visible.
export const removeNoscript = (html: string) =>
	html.replace(/<noscript\b[^>]*>[\s\S]*?<\/noscript>/gi, '')

export const addExplicitStyle = (head: HTMLHeadElement) => {
	let html = head.outerHTML

	// in production build styled components styles are not written as plain HTML, they are injected using CSSOM API
	// they are attached to <style data-styled="active"> node, so we need to get them and write them as plain HTML
	const styledComponentStyleNode = head.querySelector<HTMLStyleElement>(
		'style[data-styled="active"]',
	)
	if (styledComponentStyleNode) {
		let stylesAsHTML = ''
		const rules = styledComponentStyleNode.sheet?.cssRules

		if (rules) {
			for (const rule of rules) {
				stylesAsHTML += `${rule.cssText}\n`
			}

			const styleNode = `<style type="text/css">${stylesAsHTML}</style>`

			html = html.replace('</head>', `${styleNode}</head>`)
		}
	}

	return html
}

// The doctype keeps the receiver in standards mode, like the cockpit page itself.
export const serializeSnapshot = () =>
	`<!DOCTYPE html><html>${fixPaths(
		removeScripts(addExplicitStyle(document.head)),
	)}${fixPaths(removeNoscript(removeScripts(document.body.outerHTML)))}</html>`
